import React from "react";
import { Column } from "@/components/Datatable/types";
import { Badge } from "@/components/Badge/Badge";
import ProcessWheelActionMenu from "../ProcessWheelActionMenu/ProcessWheelActionMenu";
import { ProcessWheel } from "../../api/getProcessWheels/types";

interface CreateProcessWheelColumnsProps {
  onView: (processWheel: ProcessWheel) => void;
  onEdit: (processWheel: ProcessWheel) => void;
  onDelete: (processWheel: ProcessWheel) => void;
}

export function createProcessWheelColumns({
  onView,
  onEdit,
  onDelete,
}: CreateProcessWheelColumnsProps): Column<ProcessWheel>[] {
  return [
    {
      header: "Name",
      accessorKey: "name",
      enableSorting: true,
      cell: ({ row }) => row.original.name || "—",
    },
    {
      header: "Description",
      accessorKey: "description",
      enableSorting: true,
      cell: ({ row }) => row.original.description || "—",
    },
    {
      header: "Status",
      accessorKey: "isDeleted",
      cell: ({ row }) =>
        row.original.isDeleted ? (
          <Badge variant="grey">Inactive</Badge>
        ) : (
          <Badge variant="success">Active</Badge>
        ),
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <ProcessWheelActionMenu
          onDelete={onDelete}
          onEdit={onEdit}
          onView={onView}
          processWheel={row.original}
        />
      ),
    },
  ];
}
